module.exports = __webpack_public_path__ + "img/0-24.d6da70da.jpg";